var React = require('react');

function IconProduct (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#2e9942;}")),React.createElement("title",{"key":1},"Asset 3"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"className":"cls-1","d":"M21.53,18,36.9,12.4V27.68L21.53,36.06ZM3.22,9.18,20,3.08l16.77,6.1L20,15.28ZM39.43,7.47A3,3,0,0,0,38,6.34L21,.19a3,3,0,0,0-2.11,0L2,6.34A3,3,0,0,0,.55,7.47,3,3,0,0,0,0,9.23V27.68a3,3,0,0,0,.43,1.56,3.07,3.07,0,0,0,1.18,1.13l16.91,9.23a3,3,0,0,0,2.93,0l16.91-9.23a3.07,3.07,0,0,0,1.18-1.13A3,3,0,0,0,40,27.68V9.23A3,3,0,0,0,39.43,7.47Z"})))]);
}

IconProduct.defaultProps = {"viewBox":"0 0 39.98 39.98"};

module.exports = IconProduct;

IconProduct.default = IconProduct;
